import clsx from 'clsx'
import { ILogoProps } from './@types'

export function Logo({
  alt = 'logo',
  src = '/logo-full.svg',
  link = '/',
  target = '_self',
  className,
}: ILogoProps) {
  return (
    <a href={link} target={target as string} className="block w-max h-max">
      <img
        className={clsx(className, 'max-w-[4rem] md:w-[6rem] lg:max-w-[8rem]')}
        src={src}
        srcSet={src}
        alt={alt}
      />
    </a>
  )
}
